<template>
  <div>
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
    <div v-else class="Customer-create-page">
      <!--  credit form component -->
      <CustomerForm
        ref="customerform"
        :page="$route.params.id ? 'update' : 'create'"
        :submitted="submitted"
        v-on:FormUpdate="FormUpdate = 1"
        v-on:onSubmit="onSubmit($event)"
      ></CustomerForm>
    </div>
  </div>
</template>

<script>
import CustomerForm from "@/components/Form/Customer/CustomerForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";

export default {
  name: "CustomerCreate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    CustomerForm,
    RecordNotFound,
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
    };
  },
  methods: {
    onSubmit(ev) {
      this.submitted = true;
      var data = ev.data;
      var url = "createList";
      var text = "created";
      if (this.$route.params.id) {
        data = {
          id: this.$route.params.id,
          field: ev.data,
        };
        url = "updateList";
        text = "updated";
      }
      this.$store
        .dispatch("customer/" + url, data)
        .then(() => {
          //  show if sales-order successfully created
          this.FormUpdate = 0; // to hide before route leave confirmation message
          var message, type;
          if (this.status_code == 200) {
            if (!this.$route.params.id) {
              this.$router.push({
                name: "CustomerView",
                params: { id: this.updated_id },
              });
            } else {
              this.$router.push({
                name: "CustomerView",
                params: { id: this.$route.params.id },
              });
            }
          } else {
            this.submitted = false;
          }
          if (this.show_modal != "modal") {
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true,
            });
          }
          if (this.show_modal == "modal") {
            this.$refs.customerform.OpenSettingsModal();
          }
        })
        .catch(() => {});
    },
  },
 async beforeRouteEnter(routeTo, routeFrom, next) {
   await store
      .dispatch(
        "customer/fetchCustomerDetails",
        JSON.stringify({
          type: "customer",
        })
      )
      .then(() => {
        next();
      });
        await store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Customer",
        stg_name: "cus_settings_details"
      })
      .then(() => {
        next();
      });
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  updated: function () {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      status_code: (state) => state.customer.status_code,
      status_message: (state) => state.customer.status_message,
      status_type: (state) => state.customer.status_type,
      code: (state) => state.customer.code,
      message: (state) => state.customer.message, // to show any error nessage occurs
      updated_id: (state) => state.customer.updated_id,
      show_modal: (state) => state.customer.show_modal, // to show settings redirect modal
    }),
  },
};
</script> 

<style>
</style>
